import { ResourceCenterItem } from '@treasury/domain/dashboard/resource-center-item.entity';
import { html } from 'lit';

export class ResourceCenterItemVm {
    constructor(private readonly resource: ResourceCenterItem) {}

    public get title() {
        return html`<span>${this.resource.title}</span>`;
    }

    public get titleText() {
        return this.resource.title;
    }

    public get link() {
        return this.resource.link;
    }

    public get tooltip() {
        return this.resource.tooltip;
    }

    public get displayExternalWarning() {
        return this.resource.displayExternalWarning;
    }

    public get externalWarningMessage() {
        return this.resource.externalWarningMessage;
    }

    public get sequence() {
        return this.resource.sequence;
    }

    public get logo() {
        return this.resource.logo;
    }
}
